import { cn } from '@/lib/utils'
import type { LabelWidth } from '@/types/cgt'
import type { SectionWidth } from './types'

export const SECTION_WIDTH_COLUMNS: Record<SectionWidth, number> = {
  full: 1,
  half: 2,
  third: 3,
  quarter: 4,
}

export function WidthSkeleton({ columns }: { columns: number }) {
  return (
    <span className='flex h-3 w-full items-center gap-0.5'>
      {Array.from({ length: columns }).map((_, i) => (
        <span
          key={i}
          className={cn('h-full flex-1 rounded-[2px]', i === 0 ? 'bg-primary' : 'bg-muted-foreground/25')}
        />
      ))}
    </span>
  )
}

// Label bar share per label width preset. Literal strings so Tailwind's JIT
// compiler emits them.
const LABEL_BAR_CLASS: Record<LabelWidth, string> = {
  narrow: 'w-1/4',
  medium: 'w-2/5',
  wide: 'w-3/5',
}

/** A label bar beside a control bar, for the label width picker (z8nrz7djyx). */
export function LabelWidthSkeleton({ width }: { width: LabelWidth }) {
  return (
    <span className='flex h-3 w-full items-center gap-0.5'>
      <span className={cn('h-full shrink-0 rounded-[2px] bg-primary', LABEL_BAR_CLASS[width])} />
      <span className='h-full flex-1 rounded-[2px] bg-muted-foreground/25' />
    </span>
  )
}
